import { createContext } from 'react'
import { WhichWeightAPI } from 'WhichWeightAPI'

export const APIContext = createContext()

export const APIContextProvider = ({ children }) => {

    const ActivateGroupEquipmentProfile = async (groupId, equipmentProfileId) => {
        try {
            const jsonBody = {
                groupId: groupId,
                equipmentProfileId: equipmentProfileId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/activate_group_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const ActivateIndividualEquipmentProfile = async (userId, equipmentProfileId) => {
        try {
            const jsonBody = {
                userId: userId,
                equipmentProfileId: equipmentProfileId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'POST', '/activate_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const ArchiveKinesisProfileEvent = async (kinesisUserGroupId, userId, eventId) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                eventId: eventId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'POST', '/archive_kinesis_profile_event', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const CreateExerciseCollection = async (name) => {
        try {
            const jsonBody = {
                name: name
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/create_exercise_collection', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const CreateGroupEquipmentProfile = async (groupId, name, description, activateOnSave, equipmentProfileJSON) => {
        try {
            const jsonBody = {
                groupId: groupId,
                name: name,
                description: description,
                activateOnSave: activateOnSave,
                equipmentProfileJSON: JSON.stringify(equipmentProfileJSON)
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/create_group_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const CreateIndividualEquipmentProfile = async (userId, name, description, activateOnSave, equipmentProfileJSON) => {
        try {
            const jsonBody = {
                userId: userId,
                name: name,
                description: description,
                activateOnSave: activateOnSave,
                equipmentProfileJSON: JSON.stringify(equipmentProfileJSON)
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'POST', '/create_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const CreateProgram = async (name, description, programConfigKey) => {
        try {
            const jsonBody = {
                programName: name,
                programDescription: description,
                programConfigKey: programConfigKey
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/create_program', jsonBody)

            // console.log(result)
            
            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            var newProgramId = result.data.data
            
            return newProgramId
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const DiscardActiveWorkoutV5 = async (workoutIds) => {
        try {
            const jsonBody = {
                workoutIds: workoutIds
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'PATCH', '/discard_active_workout_v5', jsonBody)

            // console.log(result)

            if (result.data.status == 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const DeleteProgram = async (programId) => {
        try {
            const jsonBody = {
                programId: programId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/delete_program', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }
    
    const DuplicateProgram = async (sourceProgramSelectionType, programId, kinesisUserGroupId, userId, sportId) => {
        try {
            const jsonBody = {
                sourceProgramSelectionType: sourceProgramSelectionType,
                programId: programId,
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                sportId: sportId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/duplicate_program', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            var newProgramId = result.data.data
            
            return newProgramId
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const EditKinesisProfileEvent = async (eventId, eventName, eventType, eventTrainingStartDate, eventDate, boilerplateEnabled) => {
        try {
            const jsonBody = {
                eventId: eventId,
                eventName: eventName,
                eventType: eventType,
                eventTrainingStartDate: eventTrainingStartDate,
                eventDate: eventDate,
                boilerplateEnabled: boilerplateEnabled
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'PATCH', '/edit_event', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const GenerateExerciseCollectionFromPrompt = async (prompt) => {
        try {
            const jsonBody = {
                prompt: prompt
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/generate_exercise_collection_from_prompt', jsonBody)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetARaceProgramStartDate = async (kinesisUserGroupId, userId, eventTrainingStartDate, eventDate, excludeEventId = null) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                eventTrainingStartDate: eventTrainingStartDate,
                eventDate: eventDate,
                excludeEventId: excludeEventId
            }

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/a_race_program_start_date', jsonBody)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetExerciseCollection = async (exerciseCollectionId) => {
        try {
            const jsonBody = {
                exerciseCollectionId: exerciseCollectionId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/exercise_collection', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetExerciseCollectionList = async () => {
        try {
            const result = await WhichWeightAPI('PROGRAM', 'GET', '/exercise_collection_list')

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetExerciseInstructions = async (exerciseId) => {
        try {
            const jsonBody = {
                exerciseId: exerciseId
            }

            const result = await WhichWeightAPI('CORE', 'GET', '/exercise_instructions', jsonBody)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetGroupAthletes = async (groupId) => {
        try {
            const jsonBody = {
                groupId: groupId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('REPORTING', 'GET', '/group_athletes', jsonBody)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return []
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return []
        }
    }

    const GetGroupEquipmentProfiles = async (groupId) => {
        try {
            const jsonBody = { 
                groupId: groupId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/group_equipment_profiles', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return []
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return []
        }
    }

    const GetGroupFitnessProfile = async (groupId) => {
        try {
            const jsonBody = {
                groupId: groupId,
            }

            // console.log(jsonBody);

            const result = await WhichWeightAPI('REPORTING', 'GET', '/group_fitness_profile', jsonBody)

            // console.log(result.data.data);

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetIndividualEquipmentProfiles = async (userId) => {
        try {
            const jsonBody = { 
                userId: userId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'GET', '/equipment_profiles', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return []
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return []
        }
    }

    const GetIndividualFitnessProfile = async (userId) => {
        try {
            const jsonBody = {
                traineeId: userId,
            }

            // console.log(jsonBody);

            const result = await WhichWeightAPI('CORE', 'GET', '/trainee_fitness_profile', jsonBody)

            // console.log(result.data.data);

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetKinesisProfileEvents = async (kinesisUserGroupId, userId) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'GET', '/kinesis_profile_events', jsonBody)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return []
            }

            return result.data.data
        }
        catch (error) {
            console.error(error)
            return []
        }
    }

    const GetKinesisProfilePrograms = async (organizationId, kinesisUserGroupId, userId) => {
        try {
            const jsonBody = {
                organizationId: organizationId, // Used for authorization
                groupId: kinesisUserGroupId,
                userId: userId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/kinesis_profile_programs', jsonBody)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return []
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return []
        }
    }

    const GetKinesisProfileWorkoutCompliance = async (kinesisUserGroupId, clientDate) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                clientDate: clientDate
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/kinesis_profile_workout_v5_compliance', jsonBody)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        }
        catch (error) {
            console.error(error)
            return null
        }
    }

    const GetKinesisUserGroupDetails = async (kinesisUserGroupId) => {
        try {
            const jsonBody = {
                groupId: kinesisUserGroupId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('REPORTING', 'GET', '/group_details', jsonBody)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetMesoVolume = async (mesoVolumeId) => {
        try {
            const jsonBody = {
                mesoVolumeId: mesoVolumeId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/meso_volume', jsonBody)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetMesoVolumeConfigs = async (programId) => {
        try {
            const jsonBody = {
                programId: programId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/meso_volume_configs', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetOrganizationStats = async (organizationId, userId, userType, startDate, endDate) => {
        try {
            const jsonBody = {
                organizationId: organizationId,
                userId: userId,
                userType: userType,
                startDate: startDate,
                endDate: endDate
            }

            // console.log(jsonBody);

            const result = await WhichWeightAPI("CORE", "GET", "/organization_stats", jsonBody);

            // console.log(result.data.data);

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetPreviewTrainingCalendar = async (programId, programLevelScore, kinesisEvents, volumeDetrainingModifier, assessmentJSON, injuries, equipmentProfileJSON, workoutConfigWeekdayAssignmentsJSON, workoutConfigWeekdayAssignmentOverridesJSON, calendarStartDate, calendarEndDate) => {
        try {
            const jsonBody = {
                programId: programId,
                programLevelScore: programLevelScore,
                volumeDetrainingModifier: volumeDetrainingModifier,
                kinesisEvents: JSON.stringify(kinesisEvents ?? []),
                assessmentJSON: assessmentJSON ? JSON.stringify(assessmentJSON) : null,
                injuries: JSON.stringify(injuries ?? []),
                equipmentProfileJSON: JSON.stringify(equipmentProfileJSON),
                workoutConfigWeekdayAssignmentsJSON: JSON.stringify(workoutConfigWeekdayAssignmentsJSON ?? []),
                workoutConfigWeekdayAssignmentOverridesJSON: JSON.stringify(workoutConfigWeekdayAssignmentOverridesJSON ?? []),
                calendarStartDate: calendarStartDate,
                calendarEndDate: calendarEndDate
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/preview_training_calendar', jsonBody)

            // console.log(result.data.data)

            if (result?.data?.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetPreviewTrainingTimelineProgram = async (programId, programLevelScore, kinesisEvents, volumeDetrainingModifier) => {
        try {
            const jsonBody = {
                programId: programId,
                programLevelScore: programLevelScore,
                kinesisEvents: JSON.stringify(kinesisEvents ?? []),
                volumeDetrainingModifier: volumeDetrainingModifier
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/preview_training_timeline_program', jsonBody)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetProgramCanvasData = async (programId) => {
        try {
            const jsonBody = {
                programId: programId,
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/program_canvas', jsonBody)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            // const payloadString = JSON.stringify(result.data.data)
            // const payloadSizeBytes = new TextEncoder().encode(payloadString).length
            // const payloadSizeKB = payloadSizeBytes / 1024
            // const payloadSizeMB = payloadSizeBytes / (1024 * 1024)
            // console.log(`GetProgramConfigCanvasData payload size: ${payloadSizeKB.toFixed(2)} KB (${payloadSizeMB.toFixed(2)} MB)`)

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetProgramDirectory = async (type, page, pageSize, search, programStatusFilter, clientDate, options = {}) => {
        try {
            const jsonBody = {
                type: type,
                page: page,
                pageSize: pageSize,
                search: search,
                programStatusFilter: programStatusFilter,
                clientDate: clientDate
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/program_directory', jsonBody, options)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            if (
                error.name === 'CanceledError' ||
                error.name === 'AbortError' ||
                error.code === 'ERR_CANCELED'
            ) {
                return null
            }

            console.error(error)
            return null
        }
    }

    const GetProgramMetadata = async (programId) => {
        try {
            const jsonBody = {
                programId: programId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/program_metadata', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            // console.log(result.data.data)

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetProgramTechnicalStats = async (programId) => {
        try {
            const jsonBody = {
                programId: programId
            }

            // console.log(jsonBody)
            
            const result = await WhichWeightAPI('PROGRAM', 'GET', '/program_technical_stats', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        }
        catch (error) {
            console.error(error)
            return null
        }
    }

    const GetSports = async () => {
        try {
            const result = await WhichWeightAPI('CORE', 'GET', '/sports')

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return []
            }

            return result.data.data
        }
        catch (error) {
            console.error(error)
            return []
        }
    }

    const GetTrainingCalendarData = async (kinesisUserGroupId, userId, calendarStartDate, calendarEndDate, clientDate, options = {}) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                calendarStartDate: calendarStartDate.format('YYYY-MM-DD'),
                calendarEndDate: calendarEndDate.format('YYYY-MM-DD'),
                clientDate: clientDate
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/training_calendar', jsonBody, options)

            // console.log(result.data.data)

            if (result?.data?.status === 'failure') {
                console.error(result)
                return []
            }

            return result.data.data
        } catch (error) {
            if (
                error.name === 'CanceledError' ||
                error.name === 'AbortError' ||
                error.code === 'ERR_CANCELED'
            ) {
                return null
            }

            console.error(error)
            return []
        }
    }

    const GetTrainingTimelinePrograms = async (kinesisUserGroupId, userId, trainingTimelineStartDate, trainingTimelineEndDate, clientDate) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                trainingTimelineStartDate: trainingTimelineStartDate,
                trainingTimelineEndDate: trainingTimelineEndDate,
                clientDate: clientDate                
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/training_timeline_programs', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return []
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return []
        }
    }

    const GetUserDetails = async (userId) => {
        try {
            const jsonBody = {
                userId: userId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI("CORE", "GET", "/user_details", jsonBody)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return null;
            }

            return result.data.data;
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetWeightRecommendation = async (kinesisUserGroupId=null, userId=null, exerciseId=1, reps=10, taper=false, taperDampener=1.00, localCompletedSets = [], boilerplateEnabled = 0, workoutSlotId = null) => {
        try {
            const jsonBody = {
                groupId: kinesisUserGroupId,
                userId: userId,
                exerciseId: exerciseId,
                reps: reps,
                taper: taper ? 1 : 0,
                taperDampener: taperDampener,
                localCompletedSets: JSON.stringify(localCompletedSets),
                boilerplateEnabled: boilerplateEnabled
            }

            // Only instantiated workouts have a real workoutSlotId. The backend uses it to look up the coach one-off weight for the slot
            if (workoutSlotId !== null) {
                jsonBody.workoutSlotId = workoutSlotId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/weight_recommendation', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetWorkoutConfigWeekdayAssignments = async (kinesisUserGroupId, userId, clientDate) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                clientDate: clientDate
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/workout_config_weekday_assignments', jsonBody)

            // console.log(result.data.data)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetWorkoutOneOffOverrides = async (kinesisUserGroupId, userId, date, workoutConfigId, workoutVariantLetter) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                date: date,
                workoutConfigId: workoutConfigId,
                workoutVariantLetter: workoutVariantLetter
            }

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/workout_one_off_overrides', jsonBody)

            if (result.data.status === 'failure') {
                console.error(result)
                return null
            }

            return result.data.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetWorkoutV5 = async (workoutId) => {
        try {
            const jsonBody = {
                workoutId: workoutId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/workout_v5', jsonBody)

            // console.log(result.data.data)

            if (result?.data?.status === 'failure') {
                console.error(result)
                return null
            }

            return result?.data?.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const GetWorkoutV5Preview = async (workoutId) => {
        try {
            const jsonBody = {
                workoutId: workoutId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/workout_v5_preview', jsonBody)

            // console.log(result.data.data)

            if (result?.data?.status === 'failure') {
                console.error(result)
                return null
            }

            return result?.data?.data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    const RedoV5Workout = async (userId, workoutId, clientDate) => {
        try {
            const jsonBody = {
                userId: userId,
                workoutId: workoutId,
                clientDate: clientDate
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/redo_v5_workout', jsonBody)

            // console.log(result)

            if (result?.data?.status !== 'success') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const RegenerateActiveProgramIncompleteWorkouts = async (kinesisUserGroupId, userId, clientDate) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                clientDate: clientDate,
            }
            
            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/regenerate_active_program_incomplete_workouts', jsonBody)

            // console.log(result)

            if (result?.data?.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (e) {
            console.error(e)
            return false
        }
    }

    const RegenerateActiveProgramVolume = async (kinesisUserGroupId, userId, clientDate) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                clientDate: clientDate
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/regenerate_active_program_volume', jsonBody)

            // console.log(result)

            if (result?.data?.status !== 'success') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const SaveKinesisProfileEvents = async (kinesisUserGroupId, userId, kinesisEvents) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                kinesisEvents: JSON.stringify(kinesisEvents)
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'POST', '/save_kinesis_profile_events', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const StartProgramWithEventData = async (kinesisUserGroupId, userId, programId, eventData) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                programId: programId,
                eventData: eventData
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/start_program_with_event_data', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const SaveV5Workouts = async (workouts) => {
        try {
            const jsonBody = {
                workouts: workouts
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'PATCH', '/save_v5_workouts', jsonBody)

            // console.log(result)

            if (result.data.status == 'failure') {
                console.error(result)
                return false
            }

            return true
        }
        catch (error) {
            console.error(error)
            return false
        }
    }

    const StartV5Workouts = async (coachUserId, workoutIds) => {
        try {
            const jsonBody = {
                coachUserId: coachUserId,
                workoutIds: workoutIds
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'PATCH', '/start_v5_workouts', jsonBody)

            // console.log(result)

            if (result.data.status == 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const SaveWorkoutConfigWeekdayAssignmentOverride = async (kinesisUserGroupId, userId, workoutConfigId, workoutVariantLetter, date) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                workoutConfigId: workoutConfigId,
                workoutVariantLetter: workoutVariantLetter,
                date: date
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/save_workout_config_weekday_assignment_override', jsonBody)

            // console.log(result)

            if (result.data.status == 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const SaveWorkoutConfigWeekdayAssignments = async (programId, workoutConfigWeekdayAssignments, clientDate) => {
        try {
            const jsonBody = {
                programId: programId,
                workoutConfigWeekdayAssignments: workoutConfigWeekdayAssignments,
                clientDate: clientDate
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/save_workout_config_weekday_assignments', jsonBody)

            // console.log(result)

            if (result.data.status == 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const SaveWorkoutOneOffOverrides = async (kinesisUserGroupId, userId, clientDate, date, workoutConfigId, workoutVariantLetter, overrides) => {
        try {
            const jsonBody = {
                kinesisUserGroupId: kinesisUserGroupId,
                userId: userId,
                clientDate: clientDate,
                date: date,
                workoutConfigId: workoutConfigId,
                workoutVariantLetter: workoutVariantLetter,
                overrides: JSON.stringify(overrides)
            }

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/save_workout_one_off_overrides', jsonBody)

            if (result.data.status === 'failure') {
                console.error(result)
                return { success: false, message: result.data.message ?? '' }
            }

            return { success: true, message: '' }
        } catch (error) {
            console.error(error)
            return { success: false, message: '' }
        }
    }

    const UpdateGroupEquipmentProfile = async (groupId, equipmentProfileId, name, description, equipmentProfileJSON) => {
        try {
            const jsonBody = {
                groupId: groupId,
                equipmentProfileId: equipmentProfileId,
                name: name,
                description: description,
                equipmentProfileJSON: JSON.stringify(equipmentProfileJSON)
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'PATCH', '/update_group_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const UpdateIndividualEquipmentProfile = async (userId, equipmentProfileId, name, description, equipmentProfileJSON) => {
        try {
            const jsonBody = {
                userId: userId,
                equipmentProfileId: equipmentProfileId,
                name: name,
                description: description,
                equipmentProfileJSON: JSON.stringify(equipmentProfileJSON)
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'PATCH', '/update_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                console.error(result)
                return false
            }

            return true
        } catch (error) {
            console.error(error)
            return false
        }
    }

    const APIContextData = {
        ActivateGroupEquipmentProfile,
        ActivateIndividualEquipmentProfile,
        ArchiveKinesisProfileEvent,
        CreateExerciseCollection,
        CreateGroupEquipmentProfile,
        CreateIndividualEquipmentProfile,
        CreateProgram,
        DiscardActiveWorkoutV5,
        DeleteProgram,
        DuplicateProgram,
        EditKinesisProfileEvent,
        GenerateExerciseCollectionFromPrompt,
        GetARaceProgramStartDate,
        GetExerciseCollection,
        GetExerciseCollectionList,
        GetExerciseInstructions,
        GetGroupAthletes,
        GetGroupFitnessProfile,
        GetGroupEquipmentProfiles,
        GetIndividualFitnessProfile,
        GetIndividualEquipmentProfiles,
        GetKinesisProfileEvents,
        GetKinesisProfilePrograms,
        GetKinesisProfileWorkoutCompliance,
        GetKinesisUserGroupDetails,
        GetMesoVolume,
        GetMesoVolumeConfigs,
        GetOrganizationStats,
        GetPreviewTrainingCalendar,
        GetPreviewTrainingTimelineProgram,
        GetProgramCanvasData,
        GetProgramDirectory,
        GetProgramMetadata,
        GetProgramTechnicalStats,
        GetSports,
        GetTrainingCalendarData,
        GetTrainingTimelinePrograms,
        GetUserDetails,
        GetWeightRecommendation,
        GetWorkoutConfigWeekdayAssignments,
        GetWorkoutOneOffOverrides,
        GetWorkoutV5,
        GetWorkoutV5Preview,
        RedoV5Workout,
        RegenerateActiveProgramIncompleteWorkouts,
        RegenerateActiveProgramVolume,
        SaveKinesisProfileEvents,
        StartProgramWithEventData,
        SaveV5Workouts,
        StartV5Workouts,
        SaveWorkoutConfigWeekdayAssignmentOverride,
        SaveWorkoutConfigWeekdayAssignments,
        SaveWorkoutOneOffOverrides,
        UpdateGroupEquipmentProfile,
        UpdateIndividualEquipmentProfile
    }

    return (
        <APIContext.Provider value={APIContextData}>
            {children}
        </APIContext.Provider>
    )
}